import DiscountTagIcon from '@mui/icons-material/Loyalty'
import { Alert, AlertTitle } from '@mui/material'

import { i18WithDefault as t } from '@shared/locale'
import { isHiddenEverywhere } from 'components-ui/src/offer_card/helper'
import { APIBookingSearchClientDtoResponse } from 'service-api/src/types/api'
import { hasOffersDiscount } from './helper'

interface SearchOffersMembershipAlertProps {
  hasMembershipsService?: boolean
  searchResults?: APIBookingSearchClientDtoResponse['results']
  isOvernight?: boolean
}

export const SearchOffersMembershipAlert = ({
  hasMembershipsService,
  searchResults,
  isOvernight = false,
}: SearchOffersMembershipAlertProps) => {
  // Ignore offers hidden by Hatch everywhere so a hidden offer can't surface the
  // membership-discount alert. No effect when nothing is hidden.
  const visibleResults = searchResults?.filter((result) => !isHiddenEverywhere(result))
  return hasMembershipsService && visibleResults?.length && hasOffersDiscount(visibleResults, isOvernight) ? (
    <Alert icon={<DiscountTagIcon />} severity="info" sx={{ mb: 3 }}>
      <AlertTitle style={{ fontWeight: '600' }}>{t('searchResults.alert.membershipDiscount')}</AlertTitle>
    </Alert>
  ) : null
}
